import axios from 'axios';
import { isEmpty } from 'lodash';

import {
  GET_INVESTOR_DETAIL,
  SET_USER_INFORMATION,
  BANK_DETAILS,
  RESET_INVESTOR,
  SET_CASH_BALANCES,
} from '../constant';

import { initLogrocket, identifySentry } from 'lib/tracking';
import { resetAdviserInvite } from './Adviser';
import { updateWhiteLabelFund } from './WhiteLabelling';

export const getInvestorDetail = () => {
  return (dispatch, getState) => {
    return axios
      .get(`investor/get-investor-detail`)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_INVESTOR_DETAIL,
            payload: response?.data?.data,
          });
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const updateInvestor = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`investor/update-account`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const login = (value, csrfToken) => {
  return (dispatch, getState) => {
    return axios
      .post(`login`, value, {
        headers: {
          'X-CSRF-Token': csrfToken,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(userInformation(response?.data?.data));
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};
export const inviteInvestorLogin = (value, csrfToken) => {
  return (dispatch, getState) => {
    return axios
      .post(`user/invite-investor-login`, value, {
        headers: {
          'X-CSRF-Token': csrfToken,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(userInformation(response?.data?.data));
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const crfToken = (value) => {
  return (dispatch, getState) => {
    return axios
      .get(`/xsrf`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const signUp = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`user/sign-up`, value)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            userInformation({
              ...response?.data?.data,
              password: value?.password,
            }),
          );
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const adviserSignUp = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`adviser/sign-up`, value)
      .then((response) => {
        if (response.status === 200) {
          dispatch(userInformation(response?.data?.data));
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const verifyEmail = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`verify-email`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const getAddress = (value) => {
  return (dispatch, getState) => {
    return axios
      .get(`investor/get-uk-address`, { params: { input: value } })
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const onboarding = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`user/onboarding/${value?._id}`, value)
      .then((response) => {
        if (response.status === 200) {
          dispatch(userInformation(response?.data?.data));
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data });
      });
  };
};

export const resendVerificationLink = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`resend-verification-link`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const logout = ({ queryClient }) => {
  return (dispatch) => {
    return axios
      .get(`logout`)
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          var d = new Date();
          d.setTime(d.getTime() + 0);
          var expires = 'expires=' + d.toUTCString();
          document.cookie = 'access_token= ;' + expires + ';path=/';
          document.cookie = '_csrf= ;' + expires + ';path=/';
          dispatch({
            type: RESET_INVESTOR,
          });
          dispatch(userInformation(null));
          dispatch(resetAdviserInvite());
          dispatch(updateWhiteLabelFund());
          if (queryClient) {
            queryClient.clear();
          }
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response?.data?.responseMsg });
      });
  };
};

export const ForgotPassword = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`forget-password`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const ResetPassword = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`reset-password`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const userInformation = (value) => {
  if (value) {
    initLogrocket(value);
    identifySentry(value);
  }

  return (dispatch) => {
    dispatch({
      type: SET_USER_INFORMATION,
      payload: value,
    });
  };
};

export const getQuestionarries = () => {
  return (dispatch, getState) => {
    return axios
      .get(`investor/question-list`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const getBankDetail = () => {
  return (dispatch) => {
    return axios
      .get(`investor/get-bank-detail`)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: BANK_DETAILS,
            payload: response?.data?.data,
          });
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const getAbandonmentCartDetail = (id, investorId) => {
  return () => {
    return axios
      .get(`user/get-abandonment-cart-detail/${id}/${investorId}`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const cancelInvestment = (id) => {
  return () => {
    return axios
      .put(`user/cancel-investment/${id}`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const completeInvestment = (id, abandonmentId, user) => {
  return (dispatch, getState) => {
    return axios
      .get(`user/complete-investment/${id}/${abandonmentId}`)
      .then((response) => {
        if (response.status === 200) {
          if (!isEmpty(response?.data?.data?.findExistingInvestor)) {
            dispatch(
              userInformation({
                ...user,
                ...response?.data?.data?.findExistingInvestor,
                token: user?.token,
              }),
            );
          }
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const findExistingUserInformation = (value) => {
  return (dispatch, getState) => {
    return axios
      .post(`user/find-existing-user`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const getCashBalances = () => {
  return (dispatch, getState) => {
    return axios
      .get(`investor/cash-balances`)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: SET_CASH_BALANCES,
            payload: response?.data?.data,
          });
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};

export const submitWithdrawalRequest = (body) => {
  return (dispatch, getState) => {
    return axios
      .post(`investor/withdrawal-request`, body)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.reject(error.response.data.responseMsg);
      });
  };
};

export const investorStatementList = (investorType) => {
  return (dispatch, getState) => {
    return axios
      .get(`user/investorCertificationQuestion/${investorType}`)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.reject(error.response.data.responseMsg);
      });
  };
};
